import ModalFormDataAndFileList from './ModalShumaFilesList-redux';

export default ModalFormDataAndFileList;
